module.exports = __webpack_public_path__ + "img/logo.04f0891d.png";